module.exports = __webpack_public_path__ + "static/media/pdr.83b2ced0.png";